
<template>
  <v-card class="chat-room">
    <v-toolbar card dense flat class="white chat-room--toolbar" light style="margin-bottom: 19px;">
      <v-btn @click="back" icon style="margin-top: 28px;" class="hidden-md-and-up">
        <v-icon color="text--secondary">keyboard_arrow_left</v-icon>
      </v-btn>
      <template v-if="fbstore.isChatOpened">
        <!-- <v-avatar size="32" class="avatar-stack" >
        <img :src="avatar" alt="">-->
        <!-- <template v-slot:activator="{ on }"> -->
        <v-toolbar-title style="margin-top: 22px;margin-left: 0px;">
          <!-- <span></span> -->
          <v-layout row style="margin-left: 1px;">
            <v-flex style="margin-top: 9px;">
              <v-avatar size="40">
                <img
                  :src="fbstore.isGroup?'group.png':(fbstore.profileImage?fbstore.profileImage:'group.png')"
                >
              </v-avatar>
            </v-flex>
            <v-flex style="height: 60px;">
              <div v-if="fbstore.isGroup">
                <div>
                  <span
                    style="margin-left: 10px;font-size: 20px;position: relative;display: block;top: 4px;overflow: hidden;white-space:nowrap;text-overflow:ellipsis;width:253px;display:inline-block;font-weight: bold;"
                  >{{fbstore.currentChanUsers}}</span>
                  <div style="position: relative;bottom: 22px;">
                    <v-btn
                      @click="showParticipants"
                      small
                      flat
                      style="font-size: xx-small;top:7px;"
                    >
                      <span>{{fbstore.currentUserscount}}</span>
                    </v-btn>
                  </div>
                </div>
              </div>
              <div v-else>
                <div>
                  <span
                    style="margin-left: 10px;font-size: 20px;position: relative;display: block;top: 16px;overflow: hidden;white-space:nowrap;text-overflow:ellipsis;width:253px;display:inline-block;font-weight: bold;"
                  >{{fbstore.currentChanUsers}}</span>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-toolbar-title>
        <!-- </template> -->
        <v-dialog v-model="dialog2" scrollable max-width="300px">
          <v-card>
            <v-card-title
              class="headline dialogheader"
              style="background-color: rgb(207, 216, 220);color:black;"
            >Participants List</v-card-title>
            <!-- <v-divider></v-divider> -->
            <v-card-text style="height: 300px;">
              <v-list-tile v-for="item in fbstore.otherChanUsers" :key="item.id" avatar>
                <v-list-tile-avatar>
                  <!-- <v-img
                    class="elevation-6"
                    src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light"
                  ></v-img>-->
                  <!-- <v-icon size="40px">account_circle</v-icon> -->
                  <v-avatar size="40">
                    <img :src="item.profile?item.profile:'user.jpg'">
                  </v-avatar>
                </v-list-tile-avatar>
                <v-card-text>{{item.name}}</v-card-text>
              </v-list-tile>

              <!-- <v-checkbox v-model="selected" label="Jacob" value="Jacob"></v-checkbox> -->
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn @click="dialog2 = false" color="error">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- </v-avatar>   -->
      </template>
      <v-spacer></v-spacer>
      <template v-if="fbstore.isChatOpened">
        <v-tooltip bottom v-if="fbstore.isChatMuted">
          <v-btn icon slot="activator" @click="mute" style="margin-top: 27px;">
            <v-icon size="20px">volume_off</v-icon>
          </v-btn>
          <span>Mute</span>
        </v-tooltip>
        <v-tooltip bottom v-else>
          <v-btn icon slot="activator" @click="Unmute" style="margin-top: 27px;">
            <v-icon size="20px">volume_up</v-icon>
          </v-btn>
          <span>Unmute</span>
        </v-tooltip>

        <v-tooltip bottom>
          <v-btn
            icon
            slot="activator"
            @click="leave"
            v-if="fbstore.isGroup"
            style="margin-top: 27px;"
          >
            <v-icon size="20px">exit_to_app</v-icon>
          </v-btn>
          <span>Leave group</span>
        </v-tooltip>
        <!-- <template v-slot:activator="{ on }"> -->
        <v-tooltip bottom>
          <v-btn
            icon
            slot="activator"
            v-show="fbstore.isGroup"
            style="margin-top: 27px;"
            @click="AddNewMember"
          >
            <v-icon size="20px" dark>person_add</v-icon>
          </v-btn>
          <span>Add user</span>
        </v-tooltip>
        <!-- </template> -->
        <v-dialog v-model="dialog1" scrollable max-width="300px">
          <v-card>
            <v-card-title
              class="headline dialogheader"
              style="background-color: rgb(207, 216, 220);color:black;"
            >Add New Member</v-card-title>
            <!-- <v-flex>
            <v-text-field label="Search user" single-line solo></v-text-field>
            </v-flex>-->
            <!-- <v-divider></v-divider> -->
            <v-card-text style="height: 300px;">
              <v-list-tile v-for="item in fbstore.ContactList" :key="item.id" avatar>
                <v-checkbox v-model="selected" :label="item.labelName" :value="item"></v-checkbox>
              </v-list-tile>

              <!-- <v-checkbox v-model="selected" label="Jacob" value="Jacob"></v-checkbox> -->
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn
                @click="addChatGroupUsers"
                :color="(selected.length == 0 && isActive)?'':'primary'"
                :disabled="selected.length == 0 && isActive"
              >Add</v-btn>
              <v-btn @click="dialog1 = false" color="error">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </v-toolbar>
    <vue-perfect-scrollbar class="chat-room--scrollbar grey lighten-5" id="container">
      <v-card-text class="chat-room--list pa-3" v-if="fbstore.isChatOpened">
        <template v-for="item in fbstore.currentChatChannel">
          <div v-if="item.sender == user" :key="item.id">
            <div class="outgoing_msg">
              <div class="sent_msg">
                <p class="message-list">{{item.message}}</p>
                <span class="time_date">{{item.date}}</span>
              </div>
            </div>

            <!-- <v-avatar class="indigo mx-1" size="40">
              <v-icon size="40px">account_circle</v-icon>
            </v-avatar>

            <div class="messaging--body layout column mx-2">
              <p style="text-align:right">{{item.sender}}</p>
              <p
                :value="true"
                v-bind:class="[ item.sender == user ? 'primary white--text' : 'white']"
                class="pa-2"
              >{{item.message}}</p>
              <div class="caption px-2 text--secondary">{{item.date}}</div>
            </div>-->
            <!-- <v-flex xs12 sm12 md6 lg6 offset-lg6 offset-md6 class="chat-card">
              <v-card color="rgb(95, 128, 65)" dark max-width="400" style="margin-left: auto;">
                <v-card-text class="font-weight-bold message-list">{{item.message}}</v-card-text>
                <v-card-actions>
                  <v-list-tile class="grow">
                    <v-list-tile-content style="width: 0px;" class="chatName">
                      <v-list-tile-title style="text-align:right">{{item.fullname}}</v-list-tile-title>
                    </v-list-tile-content>
            <v-list-tile-avatar color="grey darken-3">-->
            <!-- <v-img
                        class="elevation-6"
                        src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light"
            ></v-img>-->
            <!-- <v-icon size="40px">account_circle</v-icon>
                    </v-list-tile-avatar>
                  </v-list-tile>
                </v-card-actions>
              </v-card>
              <v-card flat max-width="400" style="margin-left: auto;">{{item.date}}</v-card>
            </v-flex>-->

            <!-- <v-spacer></v-spacer> -->
          </div>
          <div v-else>
            <div class="incoming_msg">
              <div class="incoming_withd_msg">
                <!-- <v-icon style="font-size: 40px;">account_circle</v-icon> -->
                <v-avatar size="40">
                  <img :src="item.profile?item.profile:user.jpg">
                </v-avatar>
              </div>
              <div class="received_msg">
                <div class="received_withd_msg">
                  <span class="chatName">{{item.fullname}}</span>
                  <p class="message-list">{{item.message}}</p>
                  <span class="time_date">{{item.date}}</span>
                </div>
              </div>
            </div>
            <!-- <v-flex xs12 sm12 md6 lg6>
              <v-card color="#4B698B" dark max-width="400">
                <v-card-text class="font-weight-bold message-list">{{item.message}}</v-card-text>

                <v-card-actions>
                  <v-list-tile class="grow">
            <v-list-tile-avatar color="grey darken-3">-->
            <!-- <v-img
                              class="elevation-6"
                              src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light"
            ></v-img>-->
            <!-- <v-icon size="40px">account_circle</v-icon>
                    </v-list-tile-avatar>

                    <v-list-tile-content style="width: 0px;" class="chatName">
                      <v-list-tile-title>{{item.fullname}}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-card-actions>
              </v-card>
              <v-card flat max-width="400">{{item.date}}</v-card>
            </v-flex>
            <v-spacer></v-spacer>-->
          </div>
        </template>
      </v-card-text>
    </vue-perfect-scrollbar>
    <v-card-actions style="margin-right: 10px;" class="btn-msgsend">
      <!-- <v-text-field
        full-width
        flat
        v-model="message"
        v-on:keyup.enter="send"
        clearable
        solo
        required
        :maxlength="500"
        label="Type a message here"
      ></v-text-field>-->

      <v-textarea
        box
        placeholder="Type a message here"
        full-width
        flat
        v-model="message"
        v-on:keyup.enter="send"
        class="chat-text"
        rows="3"
      ></v-textarea>

      <v-btn @click="send" icon>
        <v-icon flat icon color="black">send</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>






<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { fbstore } from "../../config/fbstore";
import { thisUser } from "../../config/fbstore";
import { debug } from "util";
export default {
  components: {
    VuePerfectScrollbar
  },
  data: function() {
    return {
      items: [],
      fbstore,
      thisUser,
      message: "",
      currentChannel: fbstore.currentChan,
      user: thisUser.name,
      avatar: "http://cdn.vuetifyjs.com/images/lists/1.jpg",
      dialog: false,
      dialog1: false,
      dialog2: false,
      selected: [],
      isActive: true
    };
  },
  methods: {
    AddNewMember() {
      this.dialog1 = true;
      this.selected = [];
    },
    showParticipants() {
      this.dialog2 = true;
    },
    send() {
      if (this.message.trim() != "") {
        fbstore.sendMessage(fbstore.currentChan, this.message);
        this.message = "";
      }
    },
    leave() {
      fbstore.leaveChannel(fbstore.currentChan);
    },
    mute() {
      fbstore.muteChannel(fbstore.currentChan);
    },
    Unmute() {
      fbstore.UnmuteChannel(fbstore.currentChan);
    },
    addChatGroupUsers() {
      this.isActive = false;
      fbstore.addUserstoExistingChannel(this.selected, fbstore.currentChan);
      this.dialog1 = false;
      this.selected = [];
      this.isActive = true;
    },
    back() {
      fbstore.showContact = true;
      fbstore.disableNewMessage(fbstore.currentChan);
    }
  },
  mounted() {
    this.$nextTick(() => {
      var container = this.$el.querySelector("#container");
      container.scrollTop = container.scrollHeight;
    });
  },
  updated() {
    var container = this.$el.querySelector("#container");
    container.scrollTop = container.scrollHeight;
  }
};
</script>

<style scoped>
.dialogheader {
  background-color: teal;
  color: white;
}

.chat-container {
  box-sizing: border-box;
  height: calc(100vh - 9rem);
  overflow-y: auto;
  padding: 10px;
  background-color: #f2f2f2;
}
.message {
  margin-bottom: 3px;
}
.message.own {
  text-align: right;
}
.chat-container .username {
  font-size: 18px;
  font-weight: 700;
}
.chat-container .content {
  padding: 8px;
  background-color: #ffffff;
  border-radius: 10px;
  display: inline-block;
  /* box-shadow: 0 1px 1px 0 rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 2px 1px -1px rgba(0,0,0,.12); */
  max-width: 50%;
  word-wrap: break-word;
}
.message.own .content {
  background-color: #b0d6fa;
}
.typer {
  box-sizing: border-box;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  bottom: 0;
  height: 4.9rem;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 -5px 10px -5px rgba(0, 0, 0, 0.2);
}

.avatar {
  float: right;
}
.avatar_left {
  float: left;
}

.v-chip.v-chip.v-chip--outline {
  background: transparent !important;
  border: 1px solid;
  color: #9e9e9e;
  height: auto;
  padding: 10px;
  text-align: right;
}
.message-list {
  word-break: break-all !important;
}

@media only screen and (min-width: 960px) {
  .chat-card {
    margin-right: 10px;
  }
  .sent_msg {
    padding: 0 10px 0px 0 !important;
  }
}

@media only screen and (min-width: 600px) {
  .btn-msgsend {
    margin-right: 150px !important;
  }
}

@media only screen and (max-width: 400px) {
  .received_msg {
    padding: 0 0 0 35px !important;
  }
}

@media only screen and (min-width: 400px) and (max-width: 600px) {
  .received_msg {
    padding: 0 0 0 25px !important;
  }
}

@media only screen and (min-width: 600px) and (max-width: 800px) {
  .received_msg {
    padding: 0 0 0 20px !important;
  }
}

@media only screen and (min-width: 1264px) {
  .incoming_withd_msg {
    width: 4% !important;
  }
  .received_msg {
    padding: 0 0 0 15px !important;
  }
}

.incoming_msg {
  overflow: hidden;
  margin: 26px 0 26px;
}
.incoming_msg_img {
  display: inline-block;
  width: 40px;
}

.incoming_withd_msg {
  display: inline-block;
  width: 6%;
}
.received_msg {
  display: inline-block;
  padding: 0 0 0 10px;
  vertical-align: top;
  width: 92%;
}

.time_date {
  color: #747474;
  display: block;
  font-size: 12px;
  margin: 8px 0 0;
}

.chatName {
  color: #747474;
  display: block;
  font-size: 12px;
  margin: 0 0 8px;
}

.sent_msg p {
  background: #b3e2c2 none repeat scroll 0 0;
  border-radius: 3px;
  font-size: 14px;
  margin: 0;
  color: #000;
  padding: 5px 10px 5px 12px;
  width: 100%;
}

.outgoing_msg {
  overflow: hidden;
  margin: 26px 0 26px;
}

.sent_msg {
  float: right;
  width: 46%;
}

.received_withd_msg p {
  background: #ebebeb none repeat scroll 0 0;
  border-radius: 3px;
  color: #646464;
  font-size: 14px;
  margin: 0;
  padding: 5px 10px 5px 12px;
  width: 100%;
}

.received_withd_msg {
  width: 57%;
}
</style>
